const baseTemplate = {
  number: 'String',
  exp_month: 'String',
  exp_year: 'String',
  cvc: 'String',
}

export default {
  withSource: {
    source: 'String',
  },
  withoutSource: baseTemplate,
}
